import type { ComponentBaseMapper } from "../types";
import { baseAlertMapper } from "./base";

export const getAlertMapper: ComponentBaseMapper = {
  ...baseAlertMapper,
};
